import React, { useEffect, useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import {
  getTypeUserSelector,
  isInstallFacilitiesSelector,
} from '../../redux/auth/selectors';
import { RootState, useAppSelector } from '../../redux/store.model';
import { getIsManagerRoleSelectorInMainWorkspace } from '../../redux/rights/selectors/rights.selector';
import { useWorkspaceManagerRight } from '../../redux/rights/hooks/useWorkspaceManagerRight';

interface HomeProps extends ConnectedComponentProps {}
/**
 * No home, just redirection to login or timers depending if is authenticated
 * */
function Home(props: Readonly<HomeProps>) {
  const { search } = useLocation();
  const { getPermission } = useWorkspaceManagerRight();
  const [url, setUrl] = useState<string | null>(null);
  const hasManagerRight = useAppSelector(
    getIsManagerRoleSelectorInMainWorkspace
  );

  useEffect(() => {
    let isMounted = true;

    const resolveUrl = async () => {
      let resolvedUrl = '/login';

      switch (props.typeUser) {
        case 'operator':
          resolvedUrl = '/operation';
          break;
        case 'manager':
          if (props.isInstallFacilitiesSelector) {
            resolvedUrl = '/install-facilities';
          } else {
            resolvedUrl = '/manager/view-locations';
          }
          break;
        default:
          if (props.isInstallFacilitiesSelector) {
            resolvedUrl = '/login-install-facilities';
          }
          break;
      }

      if (props.typeUser === 'manager') {
        const hasWorkspaceAdminRight =
          hasManagerRight || (await getPermission());
        if (hasWorkspaceAdminRight) {
          resolvedUrl = '/markets';
        }
      }

      if (search) {
        resolvedUrl += search;
      }

      if (isMounted) {
        setUrl(resolvedUrl);
      }
    };

    resolveUrl();

    return () => {
      isMounted = false;
    };
  }, [
    props.typeUser,
    props.isInstallFacilitiesSelector,
    hasManagerRight,
    getPermission,
    search,
  ]);

  if (!url) {
    return null;
  }

  return <Navigate to={url} replace />;
}

const mapStateToProps = (state: RootState) => ({
  typeUser: getTypeUserSelector(state),
  isInstallFacilitiesSelector: isInstallFacilitiesSelector(state),
});
const connector = connect(mapStateToProps);
type ConnectedComponentProps = ConnectedProps<typeof connector>;

export default connector(Home);
